/**
 * Feature flags are controlled via env vars prefixed with VITE_REACT_APP_FF_.
 * Set a flag's value to "true" to enable it; any other value (or unset) is treated as disabled.
 * Add new flags to both the FeatureFlag enum below and the featureFlags map.
 */
export enum FeatureFlag {
  Reopens = "reopens",
  MigrateToApp = "migrate_to_app",
}

const parseBooleanFlag = (value: string | undefined): boolean => value === "true";

export const featureFlags: Record<FeatureFlag, boolean> = {
  [FeatureFlag.Reopens]: parseBooleanFlag(import.meta.env.VITE_REACT_APP_FF_REOPENS),
  [FeatureFlag.MigrateToApp]: parseBooleanFlag(import.meta.env.VITE_REACT_APP_FF_MIGRATE_TO_APP),
};

export const isFeatureEnabled = (flag: FeatureFlag): boolean => {
  return featureFlags[flag];
};
